import { Accordion, Mobile, TRANSITION_END, Carousel_CoreInit } from './core'
import Header from './modules/header'
import Vh from './modules/vh'
import './modules/contact-form'
import './plugins/project-list'
import './plugins/full-screen'
import './plugins/extra-info'
import './plugins/force-image-height'

$.mlmi = {
  mobile: new Mobile(900),
}

Carousel_CoreInit()

$(function() {

  /* Header */
  Header.init()

  /* Make sure vh works on ios */
  Vh.init()

  /* Project extra info */
  $('.extra-infos-pop').each(function() {
    $(this).ExtraInfo()
  })

  /* Fade-in elements */
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  $('.fixed-content').each(function() {
    $('<div class="fixed-content__end"></div>').insertAfter($(this).closest('.row'));

    let fixedContent = $(this).find('.text-content').FixedContent({
      topBlocker: null,
      limitFromTop: 30,
      mobile: false,
      bottomBlocker: $(this).closest('.row').next('.fixed-content__end'),
    })
  })

  $('.project-list').each(function() {
    $(this).ProjectList();
  })

  $('body.--full-screen').each(function() {
    $(this).FullScreen();
  })

  $('.close-menu-btn').click(function() {
    $('body').removeClass('--menu-open')
  })

  $('.open-menu-btn').click(function() {
    $('body').addClass('--menu-open')
  })

  /* Contact form */
  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  $('.js-contact-btn').click(function() {
    $('body').toggleClass('--contact-form-open')
  })

  $('.js-contact-form__close').click(function() {
    $('body').removeClass('--contact-form-open')
  })

  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  /* Image Classes */

  $('.picture-mobile-right').each(function() {
    if ($(this).closest('.image-wrapper').length == 0) {
      $(this).wrap('<div class="picture-mobile-right-wrapper image-wrapper"></div>')
    } else {
      $(this).closest('.image-wrapper').addClass('picture-mobile-right-wrapper');
    }
  })

  $('.picture-mobile-left').each(function() {
    if ($(this).closest('.image-wrapper').length == 0) {
      $(this).wrap('<div class="picture-mobile-left-wrapper image-wrapper"></div>')
    } else {
      $(this).closest('.image-wrapper').addClass('picture-mobile-left-wrapper');
    }
  })

  $('.picture-mobile-full-width').each(function() {
    if ($(this).closest('.image-wrapper').length == 0) {
      $(this).wrap('<div class="picture-mobile-full-width-wrapper image-wrapper"></div>')
    } else {
      $(this).closest('.image-wrapper').addClass('picture-mobile-full-width-wrapper');
    }
  })

  $('.picture-desktop-2-cols').each(function() {
    if ($(this).closest('.image-wrapper').length == 0) {
      $(this).wrap('<div class="picture-desktop-2-cols-wrapper image-wrapper"></div>')
    } else {
      $(this).closest('.image-wrapper').addClass('picture-desktop-2-cols-wrapper');
    }
  })

  $('.picture-desktop-3-cols').each(function() {
    if ($(this).closest('.image-wrapper').length == 0) {
      $(this).wrap('<div class="picture-desktop-3-cols-wrapper image-wrapper"></div>')
    } else {
      $(this).closest('.image-wrapper').addClass('picture-desktop-3-cols-wrapper');
    }
  })

  $('.picture-desktop-4-cols').each(function() {
    if ($(this).closest('.image-wrapper').length == 0) {
      $(this).wrap('<div class="picture-desktop-4-cols-wrapper image-wrapper"></div>')
    } else {
      $(this).closest('.image-wrapper').addClass('picture-desktop-4-cols-wrapper');
    }
  })

  $('.force-image-height').each(function() {
    $(this).ForceImageHeight()
  })
})
